module.exports = "/_next/static/images/tools-4-a028977bbd1a142491f02cab0b27dea1.png";